/* eslint-disable react/prop-types */
import { Box, TableCell, TableRow } from "@mui/material";
import React from "react";
import Typography from "../../../../components/common/new/Typography/Typography";
import styles from "../GohonzonSubmission.styles";
import AddPlusIcon from "../../../../assets/svg/addPlusIcon";
import NewGhostTable from "../../../../components/common/new/NewGhostTable/NewGhostTable";
import useUserConfig from "../../../../hooks/useUserConfig";
import { PERMISSIONS } from "../../../../contants";

const COLS = [
  {
    displayName: "Member",
    key: "member",
  },
  {
    displayName: "RELATION",
    key: "relation",
  },
  {
    displayName: "RELATED MEMBER",
    key: "relatedMember",
  },
];

const getRows = (data) =>
  data?.map((memberData) => {
    return (
      <TableRow style={styles.tableRow}>
        <TableCell width="40%" style={styles.memberItem}>
          <Typography variant="small" color="#183053">
            {/* eslint-disable-next-line prettier/prettier  */}
            {memberData?.member?.fullName} ({memberData?.member?.memberId})
          </Typography>
        </TableCell>
        <TableCell width="30%" style={styles.memberItem}>
          <Typography variant="small" color="#183053">
            {memberData?.relationType}
          </Typography>
        </TableCell>
        <TableCell width="40%" style={styles.memberItem}>
          <Typography variant="small" color="#183053">
            {/* eslint-disable-next-line prettier/prettier  */}
            {memberData?.relatedMember?.fullName} (
            {memberData?.relatedMember?.memberId})
          </Typography>
        </TableCell>
      </TableRow>
    );
  });

function MemberRelationship({
  memberRelationship,
  showAddLink,
  onAddMember,
  onCreateFamily,
}) {
  const hasPermission = useUserConfig();
  return (
    <>
      <Box>
        <Box
          style={{
            width: "450px",
            height: "44px",
            flexShrink: "0",
            borderRadius: "35px",
            background: "#196AAB",
            marginBottom: "-25px",
            position: "relative",
            zIndex: "1",
            marginLeft: "45px",
          }}
        >
          <Typography
            variant="title3"
            style={{
              color: "#FFF",
              fontFeatureSettings: "'clig' off, 'liga' off",
              fontFamily: "Noto Sans",
              fontSize: "18px",
              fontStyle: "normal",
              fontWeight: "600",
              lineHeight: "20px",
              padding: "12px 20px 12px 20px",
              margin: "0px",
            }}
          >
            Practicing Family Members (Residing at same address)
          </Typography>
        </Box>
        {/* {memberRelationship?.length && showAddLink ? (
          <Typography
            variant="mini"
            color="#183053"
            pointer
            decoration="underline"
            weight={600}
            onClick={onAddMember}
          >
            Add member to Family
          </Typography>
        ) : (
          <Typography
            variant="mini"
            color="#183053"
            pointer
            decoration="underline"
            weight={600}
            onClick={onCreateFamily}
          >
            Create Family
          </Typography>
        )} */}
      </Box>
      <Box
        style={{
          borderRadius: "5px 5px 5px 5px",
          border: "1px solid #C2D4EB",
          background: "#F6F6F6",
          padding: "20px 0px 20px 0px",
          borderBottom: "9px solid #196AAB",
          margin: "0px 20px",
        }}
      >
        <Box
          style={{
            display: "flex",
            justifyContent: "end",
            margin: "0px 40px 10px 0px",
          }}
        >
          {hasPermission(PERMISSIONS.CREATE_NEW_FAMILY) && showAddLink && (
            <Box>
              {memberRelationship?.length ? (
                <>
                  <AddPlusIcon />
                  <Typography
                    style={{
                      color: "#00ADF8",
                      fontFeatureSettings: "'clig' off, 'liga' off",
                      fontFamily: "Noto Sans",
                      fontSize: "16px",
                      fontStyle: "normal",
                      fontWeight: "600",
                      lineHeight: "20px",
                      textDecorationLine: "underline",
                    }}
                    pointer
                    onClick={onAddMember}
                  >
                    Add member to Family
                  </Typography>
                </>
              ) : (
                <>
                  <AddPlusIcon style={{ height: "13px" }} />
                  <Typography
                    style={{
                      color: "#00ADF8",
                      fontFeatureSettings: "'clig' off, 'liga' off",
                      fontFamily: "Noto Sans",
                      fontSize: "16px",
                      fontStyle: "normal",
                      fontWeight: "600",
                      lineHeight: "20px",
                      textDecorationLine: "underline",
                    }}
                    pointer
                    onClick={onCreateFamily}
                  >
                    Create Family
                  </Typography>
                </>
              )}
            </Box>
          )}
        </Box>
        {memberRelationship?.length ? (
          <div style={{ marginBottom: "20px" }}>
            <NewGhostTable
              columns={COLS}
              rows={getRows(memberRelationship)}
              headerStyle={styles.headerStyle}
              tableHeadCellStyle={{ textAlign: "left" }}
            />
          </div>
        ) : (
          <Typography
            component="p"
            align="center"
            variant="mini"
            weight={600}
            my={7}
          >
            No Members
          </Typography>
        )}
      </Box>
    </>
  );
}

export default MemberRelationship;
